export default __webpack_public_path__ + "static/media/rad1.4c9bae6b.jpg";